module.exports = __webpack_public_path__ + "static/media/GitMenuCLI.cc71ac48.png";